import { render, staticRenderFns } from "./Pl.vue?vue&type=template&id=970bdbaa&scoped=true"
import script from "./Pl.vue?vue&type=script&lang=js"
export * from "./Pl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970bdbaa",
  null
  
)

export default component.exports